import { Component, Input, OnInit } from "@angular/core";
import { ICalculatedNPSScore } from "../nps.service";
import "./nps-gauge-horizontal.component.scss";

@Component({
    selector: "nps-gauge-horizontal",
    template: require("./nps-gauge-horizontal.component.html")
})
export class NpsGaugeHorizontal implements OnInit {
    @Input() score: ICalculatedNPSScore;

    constructor() { }

    ngOnInit() {
    }

    // ---

}
